// tasks.ts
import { registerMutation, registerQuery, registerSubscription } from "@adornis/baseql/metadata/register.js";
import { lastValueFrom } from "rxjs";
import { getTaskByID } from "./server/tasks.js";
import { TaskStatus } from "./taskStatus.js";
var waitForTaskToComplete = registerQuery({
  operationName: "waitForTaskToComplete",
  type: () => TaskStatus,
  resolve: (taskID) => async (gqlFields) => {
    const task = getTaskByID(taskID);
    if (!task)
      throw new Error(`No running Task with _id ${taskID}`);
    return lastValueFrom(task.observable);
  },
  params: [{ name: "taskID", type: () => String }]
});
var subscribeTaskStatus = registerSubscription({
  operationName: "subscribeTaskStatus",
  type: () => TaskStatus,
  resolve: (taskID) => (gqlFields) => {
    const task = getTaskByID(taskID);
    if (!task)
      throw new Error(`No running Task with _id ${taskID}`);
    return task.observable;
  },
  params: [{ name: "taskID", type: () => String }]
});
var startTask = registerMutation({
  operationName: "startTask",
  type: () => Boolean,
  resolve: (taskID) => async () => {
    const task = getTaskByID(taskID);
    if (!task)
      throw new Error(`No running Task with _id ${taskID}`);
    task.start();
  },
  params: [{ name: "taskID", type: () => String }]
});
export {
  startTask,
  subscribeTaskStatus,
  waitForTaskToComplete
};
